import React, { Component } from 'react';
import { Button } from "../common";
import { Col, Row } from "react-bootstrap";
import KeellsLogo from '../../assets/img/logo/KeellsWhiteLogo.png';
import './TrackYourOrder.scss';
import { GtagEvent } from '../../utility/googleAnalytics';

/**-- Imports for redux --*/
import { connect } from 'react-redux';
import { showMessageBox } from '../../redux/actions/messageBoxActions';
import { fetchTrackingDetail } from '../../redux/actions/trackOrderDetailAction';
import { showLoadingScreen, hideLoadingScreen } from '../../redux/actions/loadingScreenActions';

// map the redux states to props
function mapStateToProps(state) {
    return {
        responsive: state.responsive,
        loadingScreenVisible: state.loadingScreen
    }
};

// map the redux actions to props
const mapDispatchToProps = {
    showMessageBox,
    showLoadingScreen,
    hideLoadingScreen,
    fetchTrackingDetail
};

class TrackYourOrder extends Component {

    state = {
        orderNumber: "",
        authorizationField: "",
        orderNumberError: "",
        authorizationFieldError: "",
        isOrderNumberValid: true,
        isAuthorizationFieldValid: true,
        messageBox: {
            show: false,
            title: "",
            className: "",
            content: "",
            callBackFunction: null
        }
    }

    handleInputChange = event => {
        if (event.target.value == "") {
            this.setState({
                [event.target.name]: event.target.value
            })
        } else {
            if (event.target.name == "orderNumber") {
                if (!(!/^[A-Za-z0-9-?]+$/.test(event.target.value))) {
                    this.setState({
                        [event.target.name]: event.target.value.toUpperCase(),
                        orderNumberError: ""
                    })
                }
            } else if (event.target.name == "authorizationField") {
                this.setState({
                    [event.target.name]: event.target.value,
                    authorizationFieldError: ""
                })
            } else {
                this.setState({ [event.target.name]: event.target.value });
            }
        }
    };

    handleInputBlur = event => {
        if (event.target.name == "authorizationField") {
            if (event.target.value != "") {
                if (event.target.value.match(/^[0-9]+$/)) {
                    const phoneRegex = RegExp('^0[7][0-9]{8}$');
                    if (event.target.value.length != 10 || !phoneRegex.test(this.state.authorizationField.toString())) {
                        this.setState({
                            authorizationFieldError: "The number should be in the format 07XXXXXXXX"
                        })
                    }
                } else {
                    if (!(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(event.target.value)) {
                        this.setState({
                            authorizationFieldError: 'Invalid input',
                        })
                    }
                }
            } else {
                this.setState({ authorizationFieldError: "Required" })
            }
        }
        if (event.target.name == "orderNumber") {
            if (event.target.value == "") {
                this.setState({ orderNumberError: "Required" })
            }
        }
    };

    validateInputFields() {
        let isValid = true;

        if (!this.state.authorizationField || this.state.authorizationField == "") {
            isValid = false;
            this.setState({ authorizationFieldError: "Required" })
        } else {
            if (this.state.authorizationField.match(/^[0-9]+$/)) {
                const phoneRegex = RegExp('^0[7][0-9]{8}$');
                if (this.state.authorizationField.length != 10 || !phoneRegex.test(this.state.authorizationField.toString())) {
                    isValid = false;
                    this.setState({
                        authorizationFieldError: "The number should be in the format 07XXXXXXXX"
                    })
                }
            } else {
                if (!(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(this.state.authorizationField)) {
                    isValid = false;
                    this.setState({
                        authorizationFieldError: 'Invalid input',
                    })
                }
            }
        }

        if (!this.state.orderNumber || this.state.orderNumber == "") {
            isValid = false;
            this.setState({ orderNumberError: "Required" })
        }
        return isValid;
    };

    trackBtnClick() {
        if (this.validateInputFields()) {
            // GtagEvent({ action: 'submit', category: 'form', label: 'track order' });
            let encodedOrderNo = `0~${this.state.orderNumber}~UC`;
            let encodedAuthField = `0~${this.state.authorizationField}~UC`;
            const myMedRegex = /[a-zA-Z]{2}-\d{6}/g;
            if (myMedRegex.test(this.state.orderNumber)) {
                window.location.href = `/mymedtracker/${encodedOrderNo}/${encodedAuthField}`;
            } else {
                window.location.href = `/trackyourorder/${encodedOrderNo}/${encodedAuthField}`;
            }
        }
    };

    componentDidMount() {
        let orderNumber = this.props.orderNumber
        if (orderNumber) {
            this.setState({
                orderNumber: orderNumber
            })
        }
    }


    render() {
        var isMobile = this.props.responsive.isMobileLargeScreen || this.props.responsive.isMobileSmallScreen;

        var _viewClass = isMobile ? 'col-10 col-10-view' : 'col-10 col-10-view';

        return (
            <div className={`justify-content-center ${this.props.isVisible ? 'd-flex' : 'd-none'}`}>
                <Col className='track-order-container' lg="10" md="12" sm="12" xs="12">
                    <div className='first-section'>
                        <Col>
                            <img src={KeellsLogo} className="img-fluid" /> <br /> <br />
                            <span className='small-title white'><b>Track Order</b></span>
                            <br /><br />
                            <span className='description white'>Enter your order number to start tracking the status of the order</span>
                            {
                                isMobile ? null
                                    : <React.Fragment>
                                        <br />  <br />
                                        <span className='registration-bg-color'>
                                            Important: Note that only the last 5 carts shopped on www.keellssuper.com in the last 2 years will be reflected on the new site.
                                        </span>
                                    </React.Fragment>
                            }
                        </Col>
                    </div>
                    <div className='second-section'>
                        <Row className="row-view">
                            <div className={_viewClass}>
                                <div className="form-group">
                                    <label htmlFor="OrderNumber" className='white'>Your Order Number</label>
                                    <div className="input-group">

                                        <input id="orderNumber" name="orderNumber" placeholder="Order Number" type="text" className="form-control set-height-55"
                                            autoComplete="off"
                                            //maxLength={IsProduction ? 10 : 13}
                                            maxLength={(window.location.host === "www.keellssuper.com") ? 10 : 13}
                                            value={this.state.orderNumber} onChange={this.handleInputChange.bind(this)} onBlur={this.handleInputBlur.bind(this)} />
                                    </div>

                                    <span id="OrderNumberHelpBlock"
                                        className={`form-text text-muted col ${this.state.isOrderNumberValid ? '' : 'd-none'}`}>
                                        {this.state.orderNumberError}</span>

                                    <div>
                                        <label className='green-notices' style={{ marginTop: "5px" }}>Order number can be found on the order confirmation email</label>
                                    </div>
                                </div>
                            </div>
                        </Row>
                        <Row className="row-view">
                            <div className={_viewClass}>
                                <div className="form-group">
                                    <label htmlFor="OrderNumber" className='white' style={{ marginTop: "5px" }}>Your Contact Number / Email Address</label>
                                    <div className="input-group">

                                        <input id="authorizationField" name="authorizationField" placeholder="Contact Number / Email Address" type="text" className="form-control set-height-55"
                                            autoComplete="off" maxLength={100}
                                            value={this.state.authorizationField} onChange={this.handleInputChange.bind(this)} onBlur={this.handleInputBlur.bind(this)} />
                                    </div>

                                    <span id="AuthorizationFieldHelpBlock"
                                        className={`form-text text-muted col ${this.state.isAuthorizationFieldValid ? '' : 'd-none'}`}>
                                        {this.state.authorizationFieldError}</span>
                                </div>
                            </div>
                        </Row>

                        <div className='col'>
                            <div className="form-group">
                                <Button
                                    className='mt-2'
                                    onClick={this.trackBtnClick.bind(this)}
                                    primary>Submit</Button>
                            </div>
                        </div>
                    </div>
                </Col>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TrackYourOrder);
